"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/chooseSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};

type ChooseSection64sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/choose-icon-01.svg" | "/Templates/Doccure/img/icons/choose-icon-02.svg" | "/Templates/Doccure/img/icons/choose-icon-03.svg" */
    src: string;
    /** Detected variants: "No Pressure Consult" | "Flexible Scheduling" | "Risk Free Start" */
    h30Text: ReactNode;
    /** Detected variants: "Explore your options in a welcoming, judgment free" | "Evening and weekend appointments available" | "Satisfaction guaranteed or your money back" */
    p0Text: ReactNode;
    /** Detected variants: "col-sm-6 col-lg-4 d-flex" */
    className?: string;
    /** Detected variants: "choose-item-two flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName2?: string;
    /** Detected variants: "Consultation" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSeventeenChooseSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection64sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection64sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Ridely Healer" */
    sectionDiv0Div0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "0:45 Mins" */
    sectionDiv0Div0Div0Div0Div0Div0Div0P1PText?: ReactNode;
    /** Default: "Healer" */
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-02.jpg" */
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Play video" */
    sectionDiv0Div0Div0Div0Div0Link0LinkAriaLabel?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Health" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "Ready to Transform Your Balanced Health?" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Take the first step toward vibrant wellness today. Our compassionate team is here to guide you every step of the way." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    sectionDiv0Div0Div1Div1ClassName?: string;
    /** Default: "#" */
    sectionDiv0Div0Div1Div2A0AHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Div1Div2A0Span0SpanText?: ReactNode;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shape-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseSectionCircles: ChooseSectionCirclesItem[];
    chooseSection64s: ChooseSection64sItem[];
    chooseSectionCirclesItemWrapper?: (item: ChooseSectionCirclesItem, content: ReactNode) => ReactNode;
    chooseSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSection64sItemWrapper?: (item: ChooseSection64sItem, content: ReactNode) => ReactNode;
    chooseSection64sRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSection64sImageVisible?: boolean;
    chooseSection64sImageRenderer?: (item: ChooseSection64sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection64sH3Visible?: boolean;
    chooseSection64sH3Renderer?: (item: ChooseSection64sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection64sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection64sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseSection64sH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection64sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenChooseSectionGenerated: FC<HomeSeventeenChooseSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0Div0Div0P0PText = "Ridely Healer",
    sectionDiv0Div0Div0Div0Div0Div0Div0P1PText = "0:45 Mins",
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "Healer",
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose-02.jpg",
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div0Link0LinkAriaLabel = "Play video",
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "Health",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0H20H2Text = "Ready to Transform Your Balanced Health?",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0P0PText = "Take the first step toward vibrant wellness today. Our compassionate team is here to guide you every step of the way.",
    sectionDiv0Div0Div1Div2A0AHref = "#",
    sectionDiv0Div0Div1Div2A0Span0SpanText = "View All Services",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shape-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div1ClassName,
    chooseSectionCircles,
    chooseSection64s,
    chooseSectionCirclesItemWrapper,
    chooseSectionCirclesRenderer,
    chooseSection64sItemWrapper,
    chooseSection64sRenderer,
    chooseSection64sImageVisible,
    chooseSection64sImageRenderer,
    chooseSection64sH3Visible,
    chooseSection64sH3Renderer,
    chooseSection64sImageProps,
    chooseSection64sH3Props,
}) => {
    return (
        <>
            <section className="choose-section-seventeen section">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-5">
                            <div className="choose-image">
                                {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                <div className="choose-video">
                                    <div className="choose-info">
                                        {renderNode(sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                        <div>
                                            <p className="title mb-1">{sectionDiv0Div0Div0Div0Div0Div0Div0P0PText}</p>
                                            <p>{sectionDiv0Div0Div0Div0Div0Div0Div0P1PText}</p>
                                        </div>
                                    </div>
                                    {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} className="video-icon bg-white" aria-label={sectionDiv0Div0Div0Div0Div0Link0LinkAriaLabel} onClick={() => onOpenLightbox?.(0)} style={{ background: "none", border: "none", cursor: "pointer" }} {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            <i className="isax isax-play"></i>
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                    <h2 className="section-title text-gradient" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>{sectionDiv0Div0Div1Div0H20H2Text}</h2>
                                ))}
                                <p className="description">{sectionDiv0Div0Div1Div0P0PText}</p>
                            </div>
                            <div className={sectionDiv0Div0Div1Div1ClassName ?? "row justify-content-center g-4"}>
                                {renderCollectionNode(
                                    chooseSection64s,
                                    (item: ChooseSection64sItem) => (
                                        <div className={item.className ?? "col-sm-6 col-lg-4 d-flex"} key={item.key}>
                                            <div className={item.div0ClassName ?? "choose-item-two flex-fill"}>
                                                <div className={item.div0ClassName2 ?? "choose-icon"}>
                                                    {renderItemNode(chooseSection64sImageVisible, chooseSection64sImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "Consultation"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof chooseSection64sImageProps === "function" ? chooseSection64sImageProps(item) : (chooseSection64sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                                {renderItemNode(chooseSection64sH3Visible, chooseSection64sH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseSection64sH3Props === "function" ? chooseSection64sH3Props(item) : (chooseSection64sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p>{item.p0Text}</p>
                                            </div>
                                        </div>
                                    ),
                                    chooseSection64sItemWrapper,
                                    chooseSection64sRenderer
                                )}
                            </div>
                            <div className="view-top">
                                <a href={sectionDiv0Div0Div1Div2A0AHref} className="theme-17-btn">
                                    <span className="text">{sectionDiv0Div0Div1Div2A0Span0SpanText}</span>
                                    <span className="icon">
                                        <i className="isax isax-arrow-right-1"></i>
                                    </span>
                                    <div className="container-stars">
                                        <div className="stars"></div>
                                    </div>
                                    <div className="glow">
                                        {renderCollectionNode(
                                            chooseSectionCircles,
                                            (item: ChooseSectionCirclesItem) => (
                                                <div className={item.className ?? "circle"} key={item.key}></div>
                                            ),
                                            chooseSectionCirclesItemWrapper,
                                            chooseSectionCirclesRenderer
                                        )}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="choose-bg-01 rotate-anime" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSeventeenChooseSectionGenerated;
